// from https://gitlab-app.eng.qops.net/project-framework/ui/resource-list/-/blob/master/packages/resource-list-ui/src/util/typeMapper.ts
import {
  ProjectIcon,
  SurveyIcon,
  DashboardIcon,
  Employee360Icon,
  EmployeeAdHocIcon,
  EmployeeEngagementIcon,
  EmployeeLifecycleIcon,
  MouseTrailIcon,
  FeedbackIcon,
  FolderIcon,
  ProgramIcon,
  ImportedDataIcon,
  ReputationManagementIcon,
  CrossAnalyticsIcon,
  ReportIcon,
  UnmoderatedUserTestingIcon,
  SocialChannelsIcon,
  ExperienceTransparencyIcon,
  EXCOVIDReturnToWorkIcon,
  BubbleDotsIcon,
} from '@qualtrics/ui-react/icons';

const projectTypeIconMap = {
  // General
  folder: { icon: FolderIcon, color: '#515559' },
  projects: { icon: ProjectIcon, color: '#788A91' },
  // Program Types
  dx: { icon: ProgramIcon, color: '#4F5960' },
  GlobalBrandTracker: { icon: ProgramIcon, color: '#4F5960' },
  CandidateExperience: { icon: ProgramIcon, color: '#4F5960' },
  XMProgram: { icon: ProgramIcon, color: '#4F5960' },
  ConceptTesting: { icon: ProgramIcon, color: '#4F5960' },
  // Project Types
  basicSurvey: { icon: SurveyIcon, color: '#0B6ED0' },
  siteIntercept: { icon: MouseTrailIcon, color: '#E9730C' },
  featureRequest: { icon: FeedbackIcon, color: '#320B5F' },
  vocalize: { icon: DashboardIcon, color: '#6900A8' },
  vocalizeDashboard: { icon: DashboardIcon, color: '#6900A8' },
  Dashboards: { icon: DashboardIcon, color: '#6900A8' },
  threeSixty: { icon: Employee360Icon, color: '#69140B' },
  EmployeeLed360: { icon: Employee360Icon, color: '#69140B' },
  employeeLifecycle: { icon: EmployeeLifecycleIcon, color: '#095047' },
  employeeEngagement: { icon: EmployeeEngagementIcon, color: '#E21709' },
  employeeAdHoc: { icon: EmployeeAdHocIcon, color: '#91051E' },
  exCovidSolutionRtW: { icon: EXCOVIDReturnToWorkIcon, color: '#515559' },
  importedData: { icon: ImportedDataIcon, color: '#846802' },
  ImportedData: { icon: ImportedDataIcon, color: '#846802' },
  OnlineReputation: { icon: ReputationManagementIcon, color: '#FEC808' },
  Touchpoint: { icon: SurveyIcon, color: '#0B6ED0' },
  TotalReport: { icon: ReportIcon, color: '#515559' },
  FrequentPulseDashboard: { icon: DashboardIcon, color: '#6900A8' },
  CrossXMAnalytics: { icon: CrossAnalyticsIcon, color: '#515559' },
  UnmoderatedUserTesting: {
    icon: UnmoderatedUserTestingIcon,
    color: '#738FAE',
  },
  SocialChannels: { icon: SocialChannelsIcon, color: '#595959' },
  ExperienceTransparency: {
    icon: ExperienceTransparencyIcon,
    color: '#4286F5',
  },
  OXMChatProject: { icon: BubbleDotsIcon, color: '#1A3662' },
};

export const typeToIcon = (type) => {
  return projectTypeIconMap[type]?.icon || projectTypeIconMap.projects.icon;
};

export const typeToColor = (type) => {
  return projectTypeIconMap[type]?.color || '#515559';
};
